import _ from 'underscore';
import { BaseFactory } from './base-factory';
import { IConversionObject } from '../../types';

/**
 * Factory for bigint conversion object
 * @param {Object} options - input for schema property bag and i18n
 */
export class BigIntFactory extends BaseFactory {
  bigintToString(num: unknown): unknown {
    if (typeof num !== 'bigint') {
      return num;
    }

    return num.toString();
  }

  stringToBigInt(localizedString: string | null | undefined): bigint | null {
    if (_.isEmpty(localizedString)) {
      // Convert to null if string is null or empty. Leave it to required validator to raise error.
      return null;
    }
    try {
      return BigInt(localizedString);
    } catch (error) {
      return null;
    }
  }

  /**
   * Create bigint conversion object
   * @returns {Object} - conversion object that convers number to and from string
   */
  create(): IConversionObject {
    return {
      fromModel: (value: unknown): unknown => this.bigintToString(value),
      toModel: (value: string | null | undefined): bigint | null => this.stringToBigInt(value),
    } as IConversionObject;
  }
}
